import { SET_EMAIL } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_EMAIL: {
      return action.payload;
    }
    default:
      return state;
  }
};
